export enum AvatarSizes {
  EXTRA_SMALL = 80,
  SMALL = 128,
  EXTRA_LARGE = 1500
}